/* Mide clics en los upsells del cajon del carrito. Solo lectura: no cancela ni modifica el evento, ni toca el formulario ni el carrito. Todo va en try/catch. */
(function () {
  if (window.__wbUpsellTracking) return;
  window.__wbUpsellTracking = true;
  function cookie(n) {
    var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target && e.target.closest && e.target.closest('.cart-drawer__recommendations .horizontal-product__cta button');
      if (!btn) return;
      var card = btn.closest('[data-product-handle]');
      // Shopify ya no deja leer _shopify_y (ahora la cookie es _shopify_analytics y es HttpOnly): el identificador de visitante que usa el pixel es uniqToken.
      var clientId = cookie('_shopify_y');
      if (!clientId) { try { clientId = window.ShopifyAnalytics.lib.user().traits().uniqToken; } catch (e2) {} }
      if (!clientId) return;
      var payload = {
        shopDomain: 'yejcb8-1k.myshopify.com',
        eventType: 'cart_upsell_clicked',
        clientId: clientId,
        data: {
          handle: card ? card.getAttribute('data-product-handle') : null,
          kind: btn.hasAttribute('data-ebf-swap-add') ? 'bundle_swap' : (btn.type === 'submit' ? 'direct_add' : 'quick_buy'),
          page: location.pathname
        }
      };
      // text/plain evita el preflight CORS; la ruta de Tower hace request.json() igualmente
      navigator.sendBeacon('https://www.linercrm.com/api/ingest/storefront-event', new Blob([JSON.stringify(payload)], { type: 'text/plain' }));
    } catch (err) {}
  }, true);
})();
